/*================================================
  * 共通定数（グローバル変数）
================================================*/

/* ブレイクポイント定数 */
export const PC_WIDTH_MIN = 960; // PCの最小画面幅(ここからPCビュー)

/*================================================
  * 即時実行関数
================================================*/

$(function() {
    /* 入力チェック
    ------------------------------ */

    /* エンターキーでの送信をキャンセル */
    $('.js-form').keypress(function(e) {
        // textarea内の改行を許容するため条件から外す
        if (e.which === 13 &&
            e.target.tagName !== 'TEXTAREA') {
            return false;
        }
    });

    /* 検索フォームの場合はエンターキーで検索を行う */
    $('.js-search-form').keypress(function(e) {
        if (e.which === 13) {
            searchWord($(this).siblings('.js-search-button'));
        }
    });

    /* パスワードフォーム
    ------------------------------ */

    /* パスワードの表示/非表示 */
    $('.js-toggle-password').click(function() {
        const $target = $(this).siblings();
        if ($target.attr('type') === 'password') {
            $target.attr('type', 'text');
        } else {
            $target.attr('type', 'password');
        }
        $(this).toggleClass('c-icon__toggle-password--close');
    });

    /* 検索フォーム
    ------------------------------ */

    /* サジェストの表示 */
    $('.js-search-form').on('input', function() {
        clearTimeout(searchSuggestionTimer);
        const searchWord = $(this).val();
        if (typeof searchWord === 'string' && searchWord.match(/^[| |　|\r|\n|\t]*$/) === null) { // 何らかの文字が入っていたら
            $('.js-modal-search-history').hide();
            getSuggestsWord(searchWord, $(this));
        } else {
            $('.js-search-suggests').empty();
            if (SearchHistory.isExist()) {
                $('.js-modal-search-history').show();
            }
        }
    });

    /* 検索窓が押下された際に、検索モーダルを表示する */
    $('.js-header-search-form').focus(function() {
        if ($(window).width() < PC_WIDTH_MIN) {
            openModal('search');

            $('.js-search-form').not($(this))
                .val($(this).val())
                .focus();
        } else {
            openModal('search-pc');
            $('.js-search-modal-pc-overlay').show();
        }
    });

    /* 検索ボタンが押下された際に、検索モーダルを表示する(SPのみ対応) */
    $('.js-header-search-button').focus(function() {
        if ($(window).width() < PC_WIDTH_MIN) {
            openModal('search');
            const $form = $(this).siblings('.js-header-search-form');
            $('.js-search-form').not($form)
                .val($form.val())
                .focus();
        }
    });

    /* 郵便番号フォーム
    ------------------------------ */

    /* エラークラス対応 */
    $('.js-form-zipCode').keyup(function(e) {
        var $zipCodeForm = $(this).parents('.js-form-group').find('.js-form-zipCode');
        // 住所検索イベントを発火させるフォームの場合はエラーを削除する
        if (this === $zipCodeForm[$zipCodeForm.length - 1]) {
            // 郵便番号エラー文言の削除
            $('#zipCode-error').remove();
            // 都道府県、市区町村・町域、番地のエラー削除
            var $addressErrorForms;
            if ($(this).closest('.js-form').length > 0) {
                $addressErrorForms = $(this)
                    .closest('.js-form')
                    .find('.js-form-address-section');
            }
            $addressErrorForms.each(function() {
                var $addressForm = $(this).find('.js-form-address');
                // エラークラスの削除
                if ($addressForm[0].tagName === 'SELECT') {
                    $addressForm.removeClass('c-form__select--error');
                } else {
                    $addressForm.removeClass('c-form__textbox--error');
                }
                // エラー文言の削除
                $addressForm.parents('.js-form-address-section').find($("[id$='Error']")).empty();
            });
        }
    });

    /* モーダル - ナビゲーションメニュー
    ------------------------------ */

    /* ナビゲーションメニュー表示時にグレー背景を押下したらナビゲーションメニューを非表示にする */
    $('.js-nav-modal-overlay').click(function() {
        $('.js-modal-nav').removeClass('c-nav-modal--open');
        $('.js-nav-modal-overlay').hide();
    });

    /* モーダル - 検索モーダル(PC用)
    ------------------------------ */

    /* グレー背景 or ハンバーガーメニューが押下された際に、検索モーダル(PC用)を非表示にする */
    $('.js-search-modal-pc-overlay, .js-main-header__menu-button').click(function() {
        closeModal('search-pc');
        $('.js-search-modal-pc-overlay').hide();
    });

    $(window).resize(function() {
        const ScreenWidth = $(window).width(); // リサイズ後の画面幅を取得
        const isSpSize = ScreenWidth < PC_WIDTH_MIN;
        if (isSpSize && $('.js-modal-search-pc').is(':visible')) {
            closeModal('search-pc');
            $('.js-search-modal-pc-overlay').hide();
        }
        if (!isSpSize && $('.js-modal-search').is(':visible')) {
            closeModal('search');
        }
    });

    /* サイドメニューのアクティブ化
    ------------------------------ */

    if ($('#sideMenuList').length > 0) {
        var sideMenuTargetUrl = location.pathname.split('/')[1];

        // メールアドレス変更失敗画面では「会員情報」を --active にする
        if (sideMenuTargetUrl === 'error-change-email') {
            sideMenuTargetUrl = 'account';

        // クラブレコチョク連携解除確認画面では「プレイパス利用設定」を --active にする
        } else if (sideMenuTargetUrl === 'clubrecochoku') {
            sideMenuTargetUrl = 'playpass';
        }
        $('li[data-side-menu=' + sideMenuTargetUrl + ']').addClass('side-menu-list__item--active');
    }

    /* ナビゲーションメニュー カテゴリーメニューの表示/非表示
    ------------------------------ */

    $('.js-category-menu').click(function() {
        $(this).nextAll('.js-global-category-item').slideToggle();
    });

    /* WYSIWIGエディタで出力されたHTMLの調整
    ------------------------------ */

    $('.js-wysiwig-content img').each((_, img) => {
        // width属性でのサイズ指定はreset.cssで上書きされてしまうためstyleへコピー
        const attrWidth = img.getAttribute('width');
        if (!img.style.width && attrWidth) {
            img.style.width = `${attrWidth}px`;
        }
        img.style.height = 'auto'; // max-widthが適用された際に縦横比が崩れるの防ぐため常にauto
    });
});

/*================================================
  * 共通関数
================================================*/

/* 入力チェック
------------------------------ */

/**
 * 郵便番号から住所を検索
 * @param {JQuery} $button 押下した住所検索ボタン
 */
export function searchAddress($button) {
    const yubinBango = new YubinBango.Core();
    // バリデーションエラーの場合は処理を行わない
    const $zipCodeForm = $button
        .parents('.js-form-group')
        .find('.js-form-zipCode');
    if (!$zipCodeForm.valid()) {
        return;
    }
    // 郵便番号に対して住所が存在しない場合はエラー表示
    let zipCode = '';
    $zipCodeForm.each(function() {
        zipCode += $(this).val();
    });
    // 郵便番号から住所を検索
    yubinBango.i(zipCode, () => {
        // .p-postal-code(= .js-form-zipCode)を持つ最後の要素のkeyupイベントが住所入力なのでそのイベントを発火させる
        const event = new Event('keyup');
        $zipCodeForm[$zipCodeForm.length - 1].dispatchEvent(event);
        if (
            t.length === 0 ||
            t[zipCode.slice(0, 3)] === undefined ||
            t[zipCode.slice(0, 3)][zipCode] === undefined
        ) {
            var $errorForm = $('#zipCodeError');
            $errorForm
                .append('<p id="zipCode-error" class="c-form__error">該当する住所が存在しません</p>')
                .show();
        }
        // 全フォームのバリデーションエラーがなくなった場合、ページ上部エラー文言を削除しボタンを活性化する
        if ($('.c-form__error').length === 0) {
            $('.js-form-error__heading').hide();
            $('.js-form-button').removeClass('c-btn--disabled');
        }
    });
}

/**
 * フォームのバリデーション確認
 *
 * @param {JQuery} $target 関数を呼び出した要素(送信ボタンなど)
 *
 * @return {boolean} true:バリデーションOK, false:バリデーションNG
 */
export function confirmForm($target) {
    var isFormValid = $target
        .parents('.js-form')
        .valid();
    if (!isFormValid) {
        $('.js-form-button').addClass('c-btn--disabled');
        $('.js-form-error__heading').show();
        $('html, body').animate({scrollTop: 0});
        return false;
    } else {
        if ($('.js-form-button').hasClass('c-btn--disabled')) {
            $('.js-form-button').removeClass('c-btn--disabled');
        }
        $('.js-form-error__heading').hide();
        $target.css('pointer-events', 'none');

        return true;
    }
}

/* 検索フォーム
------------------------------ */

/** @type {Map<string, JQuery.jqXHR>} */
const searchSuggestionRequests = new Map();
let searchSuggestionTimer
/**
 * サジェスト
 *
 * @param {string} searchWord 検索キーワード
 * @param {JQuery} $form 検索フォーム
 */
export function getSuggestsWord(searchWord, $form) {
    // 表示されているか否かで使用する検索表示リストを選択
    const $suggestsList = $('.js-search-suggests').filter(':visible');
    $suggestsList.empty();

    const limit = $suggestsList.attr('id') === 'suggestSp' ? 5 : 10;

    const renderSuggestions = response => {
        if ($form.val().toString() !== searchWord) return; // リクエスト中に検索フォームの内容が変わっていた場合は描画しない
        if (!response.suggests?.length) return;
        const suggestionItems = response.suggests.map(suggestion => {
            return `<li class="c-list__item c-search-item">
                    <a class="c-list__item-link c-search-item__link" href="/search?q=${encodeURIComponent(suggestion)}">
                        <p class="c-list__item-text">${htmlSpecialchars(suggestion)}</p>
                    </a>
                </li>`;
        }).join('');
        $suggestsList.html(suggestionItems).show();
    }

    // 同一検索ワードのリクエストがある場合はそれを待つ
    if (searchSuggestionRequests.has(searchWord)) {
        return searchSuggestionRequests.get(searchWord).done(renderSuggestions);
    }
    // タイピングが続く場合に不要なリクエストをキャンセルできるよう遅延させる
    searchSuggestionTimer = setTimeout(() => {
        const request = $.ajax({
            type: 'GET',
            url: '/api/search/suggest',
            dataType: 'json',
            data: { q: searchWord, limit },
            cache: false
        }).done(renderSuggestions)
        searchSuggestionRequests.set(searchWord, request);
    }, 1000);
};

/**
 * 検索ワードの削除
 *
 * @param {JQuery} $deleteBtn 削除を行いたいフォームのバツボタン
 */
export function deleteSearchWord($deleteBtn) {
    // 要素の兄弟要素にある検索ボックス内のワードを削除する
    $deleteBtn
        .siblings('.js-search-form')
        .val('');
    $('.js-search-suggests').empty();
    if (SearchHistory.isExist()) {
        $('.js-modal-search-history').show();
    }
}

/**
 * 検索ワードでの検索(未入力の場合は検索結果0件表示にする)
 *
 * @param {JQuery} $target 関数を呼び出した要素(虫眼鏡ボタン)
 */
export function searchWord($target) {
    clearTimeout(searchSuggestionTimer); // 検索を確定した時点で検索サジェストの取得をキャンセル
    // 要素の兄弟要素にある検索ボックス内のワードで検索する
    const searchWord = $target.siblings('.js-search-form').val();
    location.href = '/search?q=' + encodeURIComponent(htmlSpecialchars(searchWord.toString()));
}

/**
 * 検索モーダルを閉じる(同時に検索ワードの削除を行うためcloseModal()とは別関数に)
 *
 * @param {JQuery} $target 関数を呼び出した要素(キャンセル)
 */
export function closeSearchModal($target) {
    closeModal('search');
    // 同フォームの削除ボタンを取得
    var $siblingsDeleteBtn = $target
        .parent()
        .siblings()
        .children('.js-search-delete');
    // 取得した削除ボタンを用いてdeleteSearchWord()を実行
    deleteSearchWord($siblingsDeleteBtn);
}

/* モーダル - 表示/非表示
------------------------------ */

/**
 * モーダルの表示
 *
 * @param {string} type モーダルの種類
 *     // モーダルの種類が増えたらここにアルファベット順に追加
 *     cart-add-error: カート追加エラー
 *     device-disconnect: ご利用端末解除
 *     dialog: ダイアログ
 *     entry-lottery: 抽選応募確認
 *     filter: 絞り込み
 *     funclub-only: ファンクラブ会員限定商品
 *     nav: ナビゲーション
 *     nft-owner-only-confirm: NFT所有者限定商品購入確認
 *     nft-unowned: NFT未所有
 *     recommendation-version: 推奨OS
 *     search: 検索(SP用)
 *     search-pc: 検索(PC用)
 */
export function openModal(type) {
    if (type !== 'nav') {
        $('.js-modal-' + type).show();
    } else {
        $('.js-modal-' + type)
            .addClass('c-nav-modal--open')
            // iOSのブラウザバックでちらつくバグがあるので、ここで設定する
            .css('transition', '0.2s');
        $('.js-nav-modal-overlay').show();
    }

    // 背景スクロールを禁止
    if (['filter', 'search'].includes(type)) {
        $('body').addClass('show-modal');
    }
}

/**
 * モーダルの非表示
 *
 * @param {string} type モーダルの種類
 *     // モーダルの種類が増えたらここにアルファベット順に追加
 *     cart-add-error: カート追加エラー
 *     device-disconnect: ご利用端末解除
 *     dialog: ダイアログ
 *     entry-lottery: 抽選応募確認
 *     filter: 絞り込み
 *     funclub-only: ファンクラブ会員限定商品
 *     nav: ナビゲーション
 *     nft-owner-only-confirm: NFT所有者限定商品購入確認
 *     nft-unowned: NFT未所有
 *     paid-lot: 有償くじ結果
 *     recommendation-version: 推奨OS
 *     search: 検索(SP用)
 *     search-pc: 検索(PC用)
 */
export function closeModal(type) {
    if (type !== 'nav') {
        $('.js-modal-' + type).hide();
    } else {
        $('.js-modal-' + type).removeClass('c-nav-modal--open');
        $('.js-nav-modal-overlay').hide();
    }

    $('body').removeClass('show-modal');
}

/**
 * 共通ダイアログ表示
 *
 * @param {string} displayText ダイアログの表示文言
 */
export function showDialog(displayText) {
    $('.js-dialog-modal__text').html(displayText);
    openModal('dialog');
    $('.js-dialog-modal-overlay').show();
}

/**
 * 共通ダイアログ非表示
 */
export function closeDialog() {
    closeModal('dialog');
    $('.js-dialog-modal-overlay').hide();
}

/* フォーム
------------------------------ */

/**
 * チェックボックスのON/OFF
 *
 * @param {JQuery} $target 切り替えのトリガーとなる要素(li)
 */
export function toggleCheckbox($target) {
    var isChecked = $target.find('.js-checkbox').prop('checked');
    $target.find('.js-checkbox').prop('checked', !isChecked);
    countItems();
}

/**
 * チェックボックスがcheckedになっている数を表示
 */
export function countItems() {
    $('.js-total').text($('.js-checkbox:checked').length);
}

/* 絞り込みセクション
------------------------------ */

/**
 * 入力した内容で絞り込み
 *
 * @param {JQuery} $target この条件で絞り込むボタン
 */
export function filterItems($target) {
    var filterOptions = [];
    var $forms = $target
        .parents('.js-filter-form-wrapper')
        .find('.js-filter-form');
    $forms.each(function() {
        if ($(this).val()) {
            filterOptions.push($(this).val());
        }
    });

    var i = 0;
    if (filterOptions.length > 0) {
        filterOptions.forEach(element => {
            if (i === 0) {
                $('.js-filter-options')
                    .empty()
                    .append(element);
            } else {
                $('.js-filter-options').append('、' + element);
            }
            i++;
        })
        $('.js-filter-options').removeClass('c-filter__options--placeholder');
    } else {
        // 条件がないので初期表示に戻す
        $('.js-filter-options').text('未選択');
        $('.js-filter-options').addClass('c-filter__options--placeholder');
    }
    closeModal('filter');
}

/**
 * もっとみる系API呼出し
 *
 * @param {string} controller 接続先controller
 * @param {object} params クエリパラメータ
 * @param {function} onSuccess 成功時処理
 * @param {function} onFailure 失敗時処理
 */
export function callMoreApi(controller, params, onSuccess, onFailure) {
    const urlPrefix = '/api/';
    const urlSuffix = '/more';
    $.ajax({
        type: 'GET',
        url: urlPrefix + controller + urlSuffix,
        dataType: 'json',
        data: params,
        cache: false
    }).done(function(response) {
        onSuccess(response);
    }).fail(function(response) {
        onFailure(response);
    });
}

/**
 * JsRenderによる要素描画
 *
 * 以下要素に指定のクラスを付与すること
 * ・描画先: js-render-contents
 * ・もっとみるボタン: js-more-btn
 *
 * @param {string} templateId JsRenderテンプレートID
 * @param {Array} data 描画用データ配列
 * @param {boolean} isMore もっとみる可否
 * @param {function} dataFormatter 描画用データ整形処理。引数として描画用データ配列の要素が渡される。
 *   Objectを返すこと。nullを返した場合は描画されずにスキップされる。
 * @param {string} selectorPrefix 描画先・もっとみるボタン取得時の追加セレクタ（親要素などを指定）
 */
export function render(templateId, data, isMore, dataFormatter, selectorPrefix) {
    var $moreButton = $(selectorPrefix + '.js-more-btn');
    if ($moreButton.length !== 0 && !isMore) {
        $moreButton.remove();
    }

    var html = '';
    var $template = $('#' + templateId);
    $.each(data, function(key, value) {
        var viewVariables = dataFormatter(value);
        if (viewVariables !== null) {
            html += $template.render(viewVariables);
        }
    });

    if (html !== '') {
        $(selectorPrefix + '.js-render-contents').append(html);
    }
}

/**
 * 日付フォーマット（yyyy.mm.dd形式）
 *
 * @param {string} dateString 日付文字列
 * @return {string} 日付文字列(yyyy.mm.dd)
 */
export function formatToDotDate(dateString) {
    return formatDate(dateString, '.');
}

/**
 * 日付フォーマット（yyyy/mm/dd形式）
 *
 * @param {string} dateString 日付文字列
 * @return {string} 日付文字列(yyyy/mm/dd)
 */
export function formatToSlashDate(dateString) {
    return formatDate(dateString, '/');
}

/**
 * 日付フォーマット（yyyy/mm/dd hh:mm形式）
 *
 * @param {string} dateString 日付文字列
 * @return {string} 日付文字列(yyyy/mm/dd hh:mm)
 */
export function formatToSlashDateTime(dateString) {
    return formatDate(dateString, '/', ':');
}

/**
 * 日付フォーマット
 *
 * @param {string} dateString 日付文字列
 * @param {string} delimiter 日付区切り文字
 * @param {string} delimiterTime 時間区切り文字
 * @return {string} 日付文字列(フォーマット後)
 */
export function formatDate(dateString, delimiter, delimiterTime = '') {
    var date = getJSTDate(dateString);

    var formatDate = date.getFullYear() // 年
        + delimiter + ('0' + (date.getMonth() + 1)).slice(-2)  // 月
        + delimiter + ('0' + date.getDate()).slice(-2); // 日

    if (delimiterTime !== '') {
        formatDate += ' ' + padding(date.getHours(), -2) // 時
            + delimiterTime + padding(date.getMinutes(), -2) // 分
    }

    return formatDate;
}

/**
 * 時刻をJST同等に調整したDateオブジェクトを取得する
 * 内部的なタイムゾーンは変化しないため注意すること
 *
 * @param {string} dateString 日付文字列
 * @return {Date} 時刻がJST同等に調整されたDateオブジェクト
 */
export function getJSTDate(dateString) {
    var date = new Date(dateString);
    var jstOffset = -540;
    var timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === jstOffset) {
        return date; // JST同等の時差であれば調整不要
    }

    // 現在のタイムゾーンとJSTの時差を計算
    var jstDiffTime = (timezoneOffset - jstOffset) * 60 * 1000;
    date.setTime(date.getTime() + jstDiffTime);

    return date;
}

/**
 * 金額フォーマット(カンマ区切り)
 *
 * @param {number|null} price
 * @return {string} 金額文字列(フォーマット後)
 */
export function formatPrice(price) {
    var priceString = '';
    if (price !== null) {
        priceString = (new Intl.NumberFormat('ja')).format(price);
    }

    return priceString;
}

/**
 * 表示用コンテンツタイプ名フォーマット
 *
 * @param {Array} contentTypeList
 * @return {Array} 表示用コンテンツタイプ一覧
 */
export function formatContentTypeList(contentTypeList) {
    return contentTypeList.map(({ contentType, name: oldName }) => {
        // 表示用の名称に置き換え
        const name = contentType in DISPLAY_CONTENT_TYPE_NAME_LIST
            ? DISPLAY_CONTENT_TYPE_NAME_LIST[contentType]
            : oldName;
        return { name, contentType };
    }).filter(({ name }, i, list) => {
        // 重複を除外
        const existingNames = list.slice(0, i).map(({ name }) => name);
        if (existingNames.includes(name)) return false;
        // 表示不可（null等）を除外
        if (!name) return false;
        return true;
    });
}

/**
 * 0パディング
 *
 * @param {string|number} value パディング対象値
 * @param {number} begin sliceのbeginオプション
 * @return {string} 0パディング文字列
 */
export function padding(value, begin) {
    if (value === '') {
        return '';
    }

    return ('0' + value).slice(begin);
}

/**
 * 改行コードを改行タグへ置換
 *
 * @param {string} text 置換文字列
 * @return {string} 置換後文字列
 */
export function nl2br(text) {
    if (typeof text !== 'string') {
        return '';
    }

    var replaceText = text.replace(/\\/g,'\\')
        .replace(/\r\n/g, '<br>')
        .replace(/(\n|\r)/g, '<br>');

    return replaceText;
}

/**
 * html特殊文字 エンコード
 *
 * @param {string} text エスケープ文字列
 * @return {string} htmlEncodeText エスケープされた文字列
 */
export function htmlSpecialchars(text) {
    if (typeof text !== 'string') {
        return '';
    }

    // JavaScript特殊文字 エスケープ
    var jsEncodeText = text.replace(/\\/g,'\\')
        .replace(/"/g, '\"')
        .replace(/'/g, '\'')
        .replace(/\//g, '\/')
        .replace(/</g, '\x3c')
        .replace(/>/g, '\x3e')
        .replace(/(0x0D)/g, '\r')
        .replace(/(0x0A)/g, '\n');

    // html特殊文字 エスケープ
    var htmlEncodeText = jsEncodeText.replace(/&/g,'&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    return htmlEncodeText;
}

/**
 * html特殊文字 デコード
 *
 * @param {string} html エスケープhtml文字列
 * @return {string} デコード後文字列
 */
export function htmlSpecialcharsDecode(html) {
    return $('<div></div>').html(html).text();
}

/**
 * 検索ワードを表示用にデコード（特殊文字・URI）
 *
 * @param {string} keyword 検索ワード
 * @return {string} 画面表示用検索ワード
 */
export function decodeKeywordForDisplay(keyword) {
    return htmlSpecialcharsDecode(decodeURIComponent(keyword));
}

/**
 * 有効期限チェック
 *
 * @param {string} start 開始日時
 * @param {string} end 終了日時
 *
 * @return {boolean} true:有効期限内、false:有効期限外
 */
export function isNowOpen(start, end) {
    if (start === '' || end === '') {
        return false;
    }

    var startDate = new Date(start);
    var endDate = new Date(end);
    var nowDate = getNow();
    if (startDate.getTime() <= nowDate.getTime() &&
        endDate.getTime() >= nowDate.getTime()) {
        return true;
    } else {
        return false;
    }
}

/**
 * windowサイズSP判定
 *
 * @return {boolean} true:SPサイズ、false:PCサイズ
 */
export function isWindowSizeSp() {
    if ($(window).width() < PC_WIDTH_MIN) {
        return true;
    } else {
        return false;
    }
}

/**
 * ValidityInfoが有効な期間中かどうかを判定
 *
 * @param {ValidityInfo} deal
 */
export function checkIfAvailableDeal(deal) {
    const now = getNow().getTime();
    const start = new Date(deal.startDate).getTime();
    const end = new Date(deal.endDate).getTime();
    return start <= now && end >= now;
}

/**
 * 新着商品判定
 * - 期間開始から２週間以内で許諾終了していないもの
 * - 通常/予約それぞれで表示
 * - 通常/予約それぞれで許諾が複数ある場合は最初の通常/予約許諾で判定
 *
 * @param {PeriodDeal[]} firstPeriodDeals 最初の許諾
 * @return {boolean} 判定結果
 */
export function isNewItem(firstPeriodDeals) {
    const firstPreOrderDeal = firstPeriodDeals.filter(v => v.preorderClass === 'PreOrder').map(v => v.validityInfo).find((v, _, arr) => {
        return arr.every(other => new Date(v.startDate).getTime() <= new Date(other.startDate).getTime());
    });
    const firstRegularDeal = firstPeriodDeals.filter(v => v.preorderClass === 'Regular').map(v => v.validityInfo).find((v, _, arr) => {
        return arr.every(other => new Date(v.startDate).getTime() <= new Date(other.startDate).getTime());
    });
    const deal = firstRegularDeal && (!firstPreOrderDeal || checkIfAvailableDeal(firstRegularDeal)) ? firstRegularDeal : firstPreOrderDeal;
    if (!deal || !checkIfAvailableDeal(deal)) return false;
    const period = getNow();
    period.setDate(period.getDate() - NEW_RANGE_DAYS);
    return new Date(deal.startDate).getTime() >= period.getTime(); // 2週間前よりも新しい
}

/**
 * PHPから受け取ったisXXX系のBoolean値チェック
 * ・PHPからBoolean値を受け取った時に、js側でBoolean値として解釈されないのでint型にしてチェック
 *
 * @param {1 | undefined} value
 * @return {boolean} true/false
 */
export function checkBoolean(value) {
    // 実際の引数の型的にparseIntを通すのは正しくないものの怖いので放置
    // @ts-ignore
    if (parseInt(value) === 1) {
        return true;
    } else {
        return false;
    }
}

/**
 * 表示ラベル一覧取得
 *
 * @param {object} item 商品情報
 * - labels ラベル一覧
 * - firstPeriodDeals 最初の許諾
 * - deal 直近の許諾
 * @return {object} ラベル一覧
 */
export function getLabels(item) {
    var labels = [];
    if ('labels' in item) {
        labels = [...item.labels];
    }
    var firstPeriodDeals = [];
    if ('firstPeriodDeals' in item) {
        firstPeriodDeals = item.firstPeriodDeals;
    }
    var deal = {};
    if ('deal' in item) {
        deal = item.deal;
    }

    var displayLabels = labels;
    if (isNewItem(firstPeriodDeals)) {
        displayLabels.unshift({
            'name': LABEL_NAME_NEW,
            'labelColor': LABEL_COLOR_RED,
        });
    }

    // 予約判定
    var isReserve = false;
    if ('preorderClass' in deal && deal.preorderClass === 'PreOrder') {
        isReserve = true;
    }
    // 特典ラベルの付け替え
    $.each(displayLabels, function(key, label) {
        if (label.name === LABEL_NAME_PRIVILEGE) {
            var name = LABEL_NAME_PURCHASE_PRIVILEGE;
            if (isReserve) {
                name = LABEL_NAME_PRE_ORDER_PRIVILEGE;
            }
            displayLabels[key] = {...label, name};

            return false;
        } // 登録変更されたり環境別によるID違いが起きてもいいようにIDではなくラベル名で判定
    });

    return displayLabels;
}

/**
 * 現在日時取得
 * - 仮想日設定を想定した日付で取得
 *
 * @return {Date} 現在日時
 */
export function getNow() {
    if (extraDatetime !== '') {
        // 仮想日設定 (サーバ側で有効な値かチェックしているため14桁であること想定)
        var year = extraDatetime.substring(0, 4); // 年
        var month = extraDatetime.substring(4, 6); // 月
        var day = extraDatetime.substring(6, 8); // 日
        var hour = extraDatetime.substring(8, 10); // 時
        var minute = extraDatetime.substring(10, 12); // 分
        var second = extraDatetime.substring(12, 14); // 秒
        return new Date(year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second);
    } else {
        return new Date();
    }
}

/**
 * クエリ一覧からクエリ文字列取得
 *
 * @param {object} queryList クエリ一覧
 * @return {string} クエリ文字列
 */
export function getQueryString(queryList) {
    return '?' + Object.entries(queryList).map(([key, value]) => `${key}=${value}`).join('&');
}

/**
 * 端末識別子取得
 *
 * @param {string} storageKey ストレージキー
 * @return {string} 端末識別子
 */
export function getDeviceIdentifier(storageKey) {
    if (storageKey === '') {
        return '';
    }

    // ダウンロード時にローカルストレージに設定されている
    var deviceIdentifier = getLocalStorageAll(storageKey);

    if (!deviceIdentifier ||
        (deviceIdentifier instanceof Object &&
        Object.keys(deviceIdentifier).length === 0)) { // 値がない場合は空文字を設定
        deviceIdentifier = '';
    }

    return deviceIdentifier;
}

/**
 * [非推奨] 共通ローカルストレージデータ取得
 * ※格納先を新たに追加する際はgetLocalStorage2を利用してください
 *
 * @param {string} storageKey 管理キー
 * @param {string} index データ名
 */
export function getLocalStorage(storageKey, index) {
    const item = window.localStorage.getItem(storageKey);
    if (item === null) {
        return {};
    }

    const parsedItem = JSON.parse(htmlSpecialcharsDecode(item));

    if (index === '') {
        return parsedItem;
    }
    if (index in parsedItem) {
        return parsedItem[index];
    }

    return {};
}

/**
 * [非推奨] 共通ローカルストレージデータ取得(項目指定なし)
 * ※格納先を新たに追加する際はgetLocalStorage2を利用してください
 *
 * @param {string} storageKey 管理キー
 */
export function getLocalStorageAll(storageKey) {
    return getLocalStorage(storageKey, '');
}

/**
 * [非推奨] 共通ローカルストレージ登録
 * ※格納先を新たに追加する際はsetLocalStorage2を利用してください
 *
 * @param {string} storageKey 管理キー
 * @param {any} value データ
 */
export function setLocalStorage(storageKey, value) {
    if (storageKey.length > 0) {
        window.localStorage.setItem(storageKey, htmlSpecialchars(JSON.stringify(value)));
    }
}

/**
 * @template T
 * @param {string} keyName
 * @return {T | null}
 */
export const getLocalStorage2 = (keyName) => {
    const jsonString = localStorage.getItem(keyName);
    if (!jsonString) return null;
    try {
        return JSON.parse(jsonString);
    } catch (error) {
        localStorage.removeItem(keyName); // Remove invalid item
        return null;
    }
}

/**
 * @template T
 * @param {string} keyName
 * @param {T} value
 * @return {void}
 */
export const setLocalStorage2 = (keyName, value) => {
    localStorage.setItem(keyName, JSON.stringify(value));
}

/**
 * @template T
 * @param {string} keyName
 * @return {T | null}
 */
export const getSessionStorage = (keyName) => {
    const jsonString = sessionStorage.getItem(keyName);
    if (!jsonString) return null;
    try {
        return JSON.parse(jsonString);
    } catch (error) {
        sessionStorage.removeItem(keyName); // Remove invalid item
        return null;
    }
}

/**
 * @template T
 * @param {string} keyName
 * @param {T} value
 * @return {void}
 */
export const setSessionStorage = (keyName, value) => {
    sessionStorage.setItem(keyName, JSON.stringify(value));
}

/**
 * SNSリンク生成処理
 * ・表示ページで以下ファイルが読み込まれていること
 * ・templates/element/JsRender/render_sns_link_list.ctp
 *
 * @param {string} shareText シェアテキスト
 * @param {boolean} isArtist アーティスト画面判定
 * @param {number} id 商品ID・アーティストID
 * @param {string} elementClass タグ要素のclass名
 */
export function setSnsLinkHtml(shareText, isArtist, id, elementClass = '') {
    /*
     * 以下は削除してurlを生成
     *
     * ・クエリパラメータ
     */
    var shareUrl = location.href.replace(/\?.*/g, '');

    var data = {
        'shareText': shareText,
        'url': shareUrl,
        'isPc': isPc,
        'isArtist': isArtist,
        'id': id
    };

    var html = $('#snsLinkTemplate').render(data);
    var element = '#snsLinkList';
    if (elementClass !== '') {
        element = elementClass;
    }

    $(element).empty().append(html);
}

/**
 * SNSシェア・GA4イベント送信
 * @param {string} url シェアURL
 */
export function shareSns(url) {
    dataLayer.push({
        event: 'share'
    });
    window.open(url, '_blank');
}

/**
 * 商品画像URLの取得
 *
 * @param {string} imageUrl 商品画像URLまたは空文字
 * @param {Object} queryParams 追加するクエリパラメータ（'FFw' または 'FFh' キーが含まれている必要がある）
 * @return {string} 商品画像URLまたは商品NoImage画像URL
 */
export function setItemImageUrl(imageUrl, queryParams = {}) {
    if (imageUrl === '') {
        return convertResourceUrl(DEFAULT_ITEM_NO_IMAGE_URL, queryParams);
    } else {
        return convertImageUrl(imageUrl, queryParams);
    }
}

/**
 * お気に入り登録・削除
 *
 * @param {array} idList アーティストID,商品ID一覧
 * @param {string} favoriteType お気に入り種別(artist,item)
 * @param {boolean} isAddition お気に入り登録判定
 * @param {boolean} useShowDialog 失敗時のダイアログ表示を利用するかどうか
 */
export function toggleFavorite(idList, favoriteType, isAddition, useShowDialog = true) {
    if (!isLogin) {
        login(true);

        return;
    }

    const typeText = favoriteType === 'artist' ? 'アーティスト' : '商品';
    const propText = isAddition ? '登録' : '解除';
    const errotMessage = `お気に入り${typeText}の${propText}に失敗しました。`;

    return $.ajax({
        type: 'POST',
        url: `/api/favorite/${isAddition ? 'add' : 'delete'}/${favoriteType}`,
        data: {
            'idList': idList.join(',')
        },
        headers: {
            'X-CSRF-Token': $.cookie('requestToken')
        },
        dataType: 'json',
        cache: false,
    }).done((response) => {
        if (!response.isSuccess && useShowDialog === true) {
            showDialog(errotMessage);
        }
    }).fail(() => {
        if (useShowDialog === true) {
            showDialog(errotMessage);
        }
    });
}

/**
 * お気に入りボタン要素の変更
 *
 * @param {JQuery} $button 登録ボタン
 * @param {string} favoriteType お気に入り種別(artist,item)
 * @param {boolean} isAddition お気に入り登録処理判定 (削除時はfalse)
 */
export function toggleFavoriteButtonState($button, favoriteType, isAddition) {
    const typeText = favoriteType === 'artist' ? 'アーティスト' : '商品';
    const favoriteOnClass = favoriteType === 'artist' ? 'favorite-artist-btn--on' : 'item-detail-favorite-btn-on'; // 画面によって命名のフォーマットが異なっているので注意
    const favoriteOnClassForGa4 = `ga4-favorite-${favoriteType}-out`;
    const favoriteOffClassForGa4 = `ga4-favorite-${favoriteType}-in`;
    $button
        .toggleClass(favoriteOnClass, isAddition) // 登録時に追加,削除時に削除するクラス
        .toggleClass(favoriteOnClassForGa4, isAddition) // 登録時に追加,削除時に削除するクラス
        .toggleClass(favoriteOffClassForGa4, !isAddition) // 登録時に削除,削除時に追加するクラス
        .text(`お気に入り${typeText}${isAddition ? 'の登録を解除' : 'に登録'}`); // 登録時に解除用文言,削除時に登録用文言に変更
}

/**
 * ログイン画面遷移
 *
 * @param {boolean} isRedirect ログイン後戻り先指定フラグ (true時は現在のURLを相対パスで設定)
 */
export function login(isRedirect) {
    var redirectParam = '';
    if (isRedirect) {
        redirectParam = '?redirect=' + encodeURIComponent(location.pathname + location.search);
    }

    window.location.href = '/login' + redirectParam;
}

/**
 * ブラウザ履歴に履歴情報書き込み
 *
 * @param {string} url 遷移URL
 * @param {string} title 履歴名
 * @param {string} contentsTagId 書き換え対象タグ
 */
export function writeBrowserHistory(url, title, contentsTagId) {
    var state = {
        'id': new Date().getTime(),
        'url': url,
        'title': title,
        'timeout': 0
    };

    if (contentsTagId !== '') {
        state.container = '#' + contentsTagId;
        state.fragment = '#' + contentsTagId;
    }

    history.pushState(state, title, url);
}

/**
 * 検索履歴
 */
function SearchHistoryManager() {
    // 検索履歴最大表示件数
    this.MAX_HISTORY_DISPLAY_COUNT = 10;
    // LocalStorageのKey
    this.STORAGE_KEY = 'SEARCH_HISTORY';
    // 検索履歴情報
    this.searchHistory = {
        'list': [],
    };
    // 初期処理として検索履歴情報をLocalStorageから取得する
    var searchHistory = getLocalStorageAll(this.STORAGE_KEY);
    if (searchHistory instanceof Object &&
        'list' in searchHistory &&
        searchHistory.list instanceof Array) {
        this.searchHistory = searchHistory;
    }
}
SearchHistoryManager.prototype = {
    /**
     * 検索履歴追加
     * ・新しい履歴は履歴一覧の先頭に追加される。また、履歴の重複を許容しない
     *
     * @param {string} keyword 追加する検索ワード
     * @return {boolean} 追加成功時true,失敗時false
     */
    add: function(keyword) {
        // 追加する検索ワードが適正時のみ追加
        if (this.isValid(keyword)) {
            // 履歴の重複は許容しないため排除する
            this.deleteDuplicate(keyword);

            // 検索ワードを新しい履歴として先頭に追加
            this.searchHistory.list.unshift(keyword);

            return true;
        } else {
            return false;
        }
    },

    /**
     * 検索ワードを検索履歴に追加し保存する
     *
     * @param {string} keyword 検索ワード
     */
    addKeyword: function(keyword) {
        if (this.add(keyword) === true) {
            // 履歴追加成功時のみ保存する
            this.save();
        }
    },

    /**
     * 指定された検索ワードと重複する履歴情報を削除する
     *
     * @param {string} keyword 検索ワード
     */
    deleteDuplicate: function(keyword) {
        var count = this.getCount();
        for (var i = 0; i < count; i++) {
            var historyInfo = this.searchHistory.list[i];
            if (historyInfo === keyword) {
                // 該当履歴を削除
                this.searchHistory.list.splice(i, 1);

                break;
            }
        }
    },

    /**
     * 履歴情報の件数を取得
     *
     * @return {number} 表示する履歴情報の件数
     */
    getCount: function() {
        var history = this.getHistory();

        return history.list.length;
    },

    /**
     * 履歴情報を取得
     *
     * @return {object} 表示用の履歴情報
     */
    getHistory: function() {
        return {
            'list': this.searchHistory.list,
        };
    },

    /**
     * 指定された検索ワードが履歴に追加する情報として適正か
     *
     * @param {string} keyword 検索ワード
     * @return {boolean} 適正な場合true,不正な場合false
     */
    isValid: function(keyword) {
        if (typeof keyword === 'string' && keyword !== '') {
            return true;
        } else {
            return false;
        }
    },

    /**
     * 検索履歴存在判定
     *
     * @return {boolean} 存在する場合true,存在しない場合false
     */
    isExist: function() {
        if (this.getCount() > 0) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * 履歴情報を画面表示する
     *
     * @param {string} templateId JsRenderテンプレート（script要素）のID
     * @param {string} selectorPrefix 描画先追加セレクタ（親要素などを指定）
     */
    render: function(templateId, selectorPrefix) {
        var history = this.getHistory();
        // JsRenderによる描画
        render(
            templateId,
            history.list,
            false,
            function(keyword) {
                if (keyword !== '') {
                    return {
                        'keyword': htmlSpecialchars(keyword),
                        'keywordParam': encodeURIComponent(keyword),
                    };
                } else {
                    return null;
                }
            },
            selectorPrefix
        );
    },

    /**
     * 履歴情報をLocalStorageに保存する
     */
    save: function() {
        // 履歴が最大保持件数を超えていたら超過分を削除する
        if (this.searchHistory.list.length > this.MAX_HISTORY_DISPLAY_COUNT) {
            this.searchHistory.list = this.searchHistory.list.slice(0, this.MAX_HISTORY_DISPLAY_COUNT);
        }
        setLocalStorage(this.STORAGE_KEY, this.searchHistory);
    },
};
export const SearchHistory = new SearchHistoryManager(); // 全画面で利用するためグローバル定義(差別化するためアッパーキャメル)

/**
 * 閲覧履歴（最近チェックした商品）
 */
export function BrowsingHistory() {
    // 閲覧履歴最大表示件数
    this.MAX_HISTORY_DISPLAY_COUNT = 16;
    // 閲覧履歴最大保持件数（履歴重複時に表示できる履歴が1件減ってしまうため、余分に1件保持する）
    this.MAX_HISTORY_SAVE_COUNT = this.MAX_HISTORY_DISPLAY_COUNT + 1;
    // LocalStorageのKey
    this.STRAGE_KEY = 'BROWSING_HISTORY';
    // 閲覧履歴情報
    this.browsingHistory = {
        'list': [],
    };
    // 閲覧履歴ID情報
    this.browsingHistoryIdList = {
        'list': [],
    };
    var localStorageInfo = getLocalStorageAll(this.STRAGE_KEY);
    if (localStorageInfo instanceof Object &&
        'list' in localStorageInfo &&
        localStorageInfo.list instanceof Array) {
        this.browsingHistoryIdList = localStorageInfo;
    }
    // 現在ページを履歴に追加したか
    this.isCurrentPageAdded = false;
}
BrowsingHistory.prototype = {
    /**
     * 初期化
     * - this.browsingHistoryIdListにローカルストレージ情報を設定
     * - this.browsingHistoryIdListを元に商品情報一覧取得
     * - this.browsingHistoryに商品情報一覧設定
     */
    initialize: async function() {
        var itemIdList = [];
        $.each(this.browsingHistoryIdList.list, function(key, value) {
            if ('itemId' in value) {
                var itemIds = {
                    'id': value.itemId,
                    'releasePrimaryContentId': 0
                };
                if ('primaryContentId' in value && typeof value.primaryContentId === 'number') {
                    itemIds.releasePrimaryContentId = value.primaryContentId;
                }
                itemIdList.push(itemIds);
            }
        });

        if (itemIdList.length > 0) {
            var list = [];
            await $.ajax({
                type: 'POST',
                url: '/api/item/list',
                data: {
                    'itemIdList': itemIdList
                },
                headers: {
                    'X-CSRF-Token': $.cookie('requestToken')
                },
                dataType: 'json',
                cache: false,
            }).done(function(response) {
                if ('items' in response && response.items.length > 0) {
                    list = response.items;
                }
            }).fail(function(response) {
                // 処理なし
            });
            this.browsingHistory.list = list;
        }
    },

    /**
     * 閲覧履歴追加
     *
     * 新しい履歴は履歴一覧の先頭に追加される。また、履歴の重複を許容しない。
     *
     * @param {Object} pageInfo 追加するページ情報
     * @return {boolean} 追加成功時true,失敗時false
     */
    add: function(pageInfo) {
        // 追加するページ情報が適正時のみ追加
        if (this.isValid(pageInfo)) {
            // 履歴の重複は許容しないため排除する
            this.deleteDuplicate(pageInfo);

            // ページ情報にtimestampを付加
            pageInfo.timestamp = new Date().getTime();

            // ページ情報を新しい履歴として先頭に追加
            this.browsingHistoryIdList.list.unshift(pageInfo);

            return true;
        } else {
            return false;
        }
    },

    /**
     * 現在ページを閲覧履歴に追加し保存する
     *
     * @param {Object} pageInfo ページ情報
     *  - itemId: 販売商品ID
     *  - primaryContentId: リリースプライマリコンテンツID(省略可)
     */
    addCurrentPage: function(pageInfo) {
        if (!('primaryContentId' in pageInfo)) {
            pageInfo.primaryContentId = null; // 比較に用いるのでundefined回避
        }
        if (this.add(pageInfo) === true) {
            // 履歴追加成功時のみ保存する
            this.save();

            this.isCurrentPageAdded = true;
        }
    },

    /**
     * 指定されたページ情報と重複する履歴情報を削除する
     *
     * @param {Object} pageInfo ページ情報
     */
    deleteDuplicate: function(pageInfo) {
        var count = this.browsingHistoryIdList.list.length;
        for (var i = 0; i < count; i++) {
            var historyInfo = this.browsingHistoryIdList.list[i];
            // 重複条件:商品ID(itemId)とリリースプライマリコンテンツID(primaryContentId)が一致
            if (
                historyInfo.itemId === pageInfo.itemId &&
                historyInfo.primaryContentId === pageInfo.primaryContentId
            ) {
                // 該当履歴を削除
                this.browsingHistoryIdList.list.splice(i, 1);

                break;
            }
        }
    },

    /**
     * 表示する履歴情報の件数を取得する
     *
     * @return {number} 表示する履歴情報の件数
     */
    getDisplayCount: function() {
        var historyForDisplay = this.getHistoryForDisplay();

        return historyForDisplay.list.length;
    },

    /**
     * 表示用の履歴情報を取得する
     * 履歴が追加されていた場合は、最新の履歴を現在ページとして扱い表示させない
     *
     * @return {Object} 表示用の履歴情報
     */
    getHistoryForDisplay: function() {
        var start = 0;
        // 現在ページが履歴に追加されている場合は先頭から2件目以降を表示
        if (this.isCurrentPageAdded) {
            start = 1;
        }
        var end = start + this.MAX_HISTORY_DISPLAY_COUNT;
        // 表示上限件数分の履歴を取得
        return {
            'list': this.browsingHistory.list.slice(start, end),
        };
    },

    /**
     * 指定されたページ情報が履歴に追加する情報として適正か
     *
     * @param {Object} pageInfo ページ情報
     * @return {boolean} 適正な場合true,不正な場合false
     */
    isValid: function(pageInfo) {
        if (pageInfo instanceof Object) {
            // 共通項目存在チェック
            var required = ['itemId'];
            var count = required.length;
            for (var i = 0; i < count; i++) {
                if (!(required[i] in pageInfo)) {
                    return false;
                }
            }
        } else {
            return false;
        }

        return true;
    },

    /**
     * 履歴情報を画面表示する
     *
     * @params {string} selectorPrefix 表示先要素のID
     * @params {string} templateId JsRenderテンプレート（script要素）のID
     */
    render: function(selectorPrefix, templateId) {
        var historyForDisplay = this.getHistoryForDisplay();
        // JsRenderによる描画
        render(
            templateId,
            historyForDisplay.list,
            false,
            function(item) {
                item.linkUrl = '/item/' + item.id;
                item.name = htmlSpecialchars(item.name);
                item.imageUrl = setItemImageUrl(item.imageUrl, { FFh: 288 });
                item.itemDisplayType = itemDisplayType;
                item.artistName = htmlSpecialchars(item.artistName);
                item.price = formatPrice(item.price);
                if (
                    'releasePrimaryContentId' in item &&
                    typeof item.releasePrimaryContentId === 'number' &&
                    item.releasePrimaryContentId > 0
                ) {
                    item.linkUrl += '/' + item.releasePrimaryContentId;
                }
                item.isSoldout = item.isSoldout ?? false;

                return item;
            },
            selectorPrefix
        );
    },

    /**
     * 履歴情報をLocalStorageに保存する
     */
    save: function() {
        // 履歴が最大保持件数を超えていたら超過分を削除する
        if (this.browsingHistoryIdList.list.length > this.MAX_HISTORY_SAVE_COUNT) {
            this.browsingHistoryIdList.list = this.browsingHistoryIdList.list.slice(0, this.MAX_HISTORY_SAVE_COUNT);
        }
        setLocalStorage(this.STRAGE_KEY, this.browsingHistoryIdList);
    },
};

/**
 * 注文時質問内容（ご入力内容）アコーディオン開閉
 *
 * @param {object} $target 押下されたアコーディオンボタン
 */
export function toggleItemQuestionAccordion($target) {
    const $toggleContents = $target.next('.js-collapse-list');
    // アニメーション中は作動しない様に制御
    if ($toggleContents.is(':animated')) {
        return;
    }
    $toggleContents.slideToggle();
    $target
        .children('.js-accordion')
        .toggleClass('c-confirm-question-header__icon--open')
        .toggleClass('c-confirm-question-header__icon--close');
}

/**
 * 商品・アーティスト画像のURLを変換
 * 画像サイズを指定する場合はqueryParamsで横幅(FFw)または高さ(FFh)を指定する（表示したいサイズの2倍を推奨）
 * FFwとFFhが両方指定された場合はFFwを優先する
 * 指定が無い場合はオリジナルサイズの画像が返る
 *
 * @param {string} url - 変換する元の画像URL
 * @param {Object} queryParams - 追加するクエリパラメータ
 * @returns {string} - 新しく生成された画像のURL（URLが不正な場合は空文字）
 */
export function convertImageUrl(url, queryParams = {}) {
    return buildTransformedUrl(url, imageResourceUrl, imageResourceBucket, queryParams);
}

/**
 * アーティスト・商品画像以外の画像のURLを変換
 * 画像サイズを指定する場合はqueryParamsで横幅(FFw)または高さ(FFh)を指定する（表示したいサイズの2倍を推奨）
 * FFwとFFhが両方指定された場合はFFwを優先する
 * 指定が無い場合はオリジナルサイズの画像が返る
 *
 * @param {string} url - 変換する元の画像URL
 * @param {Object} queryParams - 追加するクエリパラメータ
 * @returns {string} - 新しく生成された画像のURL（URLが不正な場合は空文字）
 */
export function convertResourceUrl(url, queryParams = {}) {
    return buildTransformedUrl(url, resourceUrl, resourceBucket, queryParams);
}

/**
 * 与えられたURLがURLクラスでパース可能かどうか判定
 * ※URL.parseはiOS17以降でしか使えないため代替
 */
function canParseUrl(url) {
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
}

/**
 * 画像のURLを変換
 * URL変換の必要がない場合は画像サイズのみ指定
 *
 * @param {string} imageUrl 変換元の画像URL
 * @param {string} transformationUrl 変換先のURL
 * @param {string} bucket 変換先のバケット名
 * @param {Object} size 画像サイズ（px）クエリを含む配列
 * @return {string} 変換された画像URL（URLが不正な場合は空文字）
 */
function buildTransformedUrl(imageUrl, transformationUrl, bucket, size) {
    if (!canParseUrl(imageUrl)) {
        return '';
    }

    let urlObj;
    // すでに変換済みのURLかどうかチェック
    if (imageUrl.includes(transformationUrl)) {
        urlObj = new URL(decodeUrlSafely(imageUrl));
    } else {
        urlObj = new URL(transformationUrl);
        const rawPath = new URL(imageUrl).pathname;
        const decodedPath = decodeUrlSafely(rawPath); // 二重にエンコードされることを防ぐために一度デコード
        urlObj.searchParams.append('p', bucket + decodedPath);
        urlObj.searchParams.append('svc', 'murket');
    }

    // FFwまたはFFhパラメータが既に存在するかチェック
    const hasFFParams = urlObj.searchParams.has('FFw') || urlObj.searchParams.has('FFh');

    // サイズ指定がある場合はFFwを優先、FFhはその次に設定
    // 既にFFパラメータが存在する場合は追加しない
    if (!hasFFParams) {
        if (size.FFw) {
            urlObj.searchParams.append('FFw', size.FFw);
        } else if (size.FFh) {
            urlObj.searchParams.append('FFh', size.FFh);
        } else {
            const maxFFw = '1280';
            urlObj.searchParams.append('FFw', maxFFw); // 元々の画像のサイズより大きい場合は画像サーバー側でリサイズされない
        }
    }

    return urlObj.toString();
}

/**
 * URLをデコードする
 * デコードに失敗した場合は元のURLオブジェクトを返す
 *
 * @param {string} url - デコード対象のURL
 * @returns {string} - デコードされたURLオブジェクト、もしくは元のURL
 */
export function decodeUrlSafely(url) {
    try {
        // デコード前後の文字列を比較して、変化がない場合は既にデコード済み
        const decodedUrl = decodeURI(url);
        if (decodedUrl === url) {
            return url;
        }
        return decodedUrl;
    } catch (e) {
        // デコードに失敗した場合（不正なエンコードの場合）は、元のパスをそのまま使用
        return url;
    }
}
